import { combineReducers } from 'redux';
import { reducer as signIn } from './sign-in/reducer';

export const authReducers = combineReducers({
  signIn,
});
